module.exports = __webpack_public_path__ + "img/10.4087e38.jpg";